export default __webpack_public_path__ + "static/media/hww.89a1c868.png";